"use client";
import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { SurveyMonkey as SurveyMonkeyUI } from "@jti/loyalty";

import { Placeholder } from "../Placeholder/Placeholder";

import type { surveyMonkeyInputs } from "./SurveyMonkey.builder";

type SurveyMonkeyBuilderProps = BuilderComponentProps<typeof surveyMonkeyInputs>;

export const SurveyMonkey: FC<SurveyMonkeyBuilderProps> = ({ scriptUrl }) => {
  if (isEditing()) {
    return <Placeholder>SurveyMonkey placeholder</Placeholder>;
  }
  return <SurveyMonkeyUI scriptUrl={scriptUrl} />;
};
